import { render, staticRenderFns } from "./member_card.vue?vue&type=template&id=72ac67be"
import script from "./member_card.vue?vue&type=script&lang=ts"
export * from "./member_card.vue?vue&type=script&lang=ts"
import style0 from "./member_card.vue?vue&type=style&index=0&id=72ac67be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports